import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'overallFidelityInfoTab',
    label: 'Info Tab',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
